import { Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { colorsByStatus } from './constants';
import { LabelByStatus } from './types';

export const UserProfileStatusBubble = ({ status }: { status: string }) => {
  const classes = useStyles(colorsByStatus[status]);

  return (
    <Box className={classes.container}>
      <Typography align="center" component="span" variant="body2">
        {[LabelByStatus[status as keyof typeof LabelByStatus]]}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles<Theme, { color: string; bgColor: string }>({
  container: {
    display: 'inline-flex',
    borderRadius: '4px',
    padding: '4px 8px',
    color: ({ color }) => color,
    backgroundColor: ({ bgColor }) => bgColor,
  },
});
